import { API } from "src/helpers";
import { SERVER_URL } from "src/config";

// Student Events/Visits (BU-2037). These live under /api/v3/student rather
// than /api/v1/partners because the caller is the student, not the partner
// staff the v1 endpoints authorise.
const STUDENT_EVENTS_URL = `${SERVER_URL}/api/v3/student/events`;

export function getStudentEvents(authToken, params) {
  return API.request({
    method: "get",
    url: STUDENT_EVENTS_URL,
    headers: {
      authentication_token: authToken,
    },
    params,
  });
}

export function getStudentEvent(authToken, id) {
  return API.request({
    method: "get",
    url: `${STUDENT_EVENTS_URL}/${id}`,
    headers: {
      authentication_token: authToken,
    },
  });
}

export function signUpForStudentEvent(authToken, id) {
  return API.request({
    method: "post",
    url: `${STUDENT_EVENTS_URL}/${id}/sign_up`,
    headers: {
      authentication_token: authToken,
    },
  });
}

export function withdrawFromStudentEvent(authToken, id) {
  return API.request({
    method: "delete",
    url: `${STUDENT_EVENTS_URL}/${id}/cancel_registration`,
    headers: {
      authentication_token: authToken,
    },
  });
}
